import { ForgotPasswordRequestVO } from "./forgotpassword.model";


export abstract class ForgotPasswordService {
    
    abstract updatePassword(forgotPasswordRequestVO: ForgotPasswordRequestVO): Promise<void>;
}


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.service.ts